<template>
  <section class="SubMenu tw-bg-gradient2-lr tw-py-6">
    <div class="ns-container">
      <div style="display: inline-block;">
        <ul class="SubMenu-list planner-form text-center">
          <li class="col-md-6 col-sm-6">
            <div
              class="input-group"
              :class="{'has-error': form.errors.has('for')}"
            >
              <input
                v-model="form.for"
                style="width:200px;"
                type="text"
                class="form-control"
              >
            </div>
          </li>

          <li class="col-md-3 col-sm-3">
            <button
              :disabled="form.busy"
              class="btn btn-default add-planner"
              type="button"
              @click.prevent="update"
            >
              Add
            </button>
          </li>

          <li class="col-md-2 col-sm-2 col-xs-12">
            <span class="more-options dropdown">
              <a
                href=""
                class="btn dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i
                  class="fas fa-ellipsis-h"
                  aria-hidden="true"
                />
              </a>
              <ul class="dropdown-menu">
                <li><a
                  role="button"
                  @click="generateEmails"
                > General Emails </a></li>
              </ul>
            </span>
          </li>
        </ul>
      </div>

      <div
        v-if="form.errors.has('for')"
        class="text-center help-block"
      >
        {{ form.errors.first('for') }}
      </div>
    </div>
  </section>
</template>

<script>
import Form from 'form-backend-validation';

export default {
  data() {
    return {
      form: new Form(
        {
          for: '',
        },
        {
          resetOnSuccess: false,
        },
      ),
    };
  },

  mounted() {},

  methods: {
    /**
     * Update the user's contact information.
     */
    resetForm() {
      this.form.for = '';
    },

    generateEmails() {
      this.form.post('/api/admin/invitations/generate-emails', this.form).then((response) => {
        Bus.$emit('refresh');
      });
    },

    update() {
      this.form.patch('/api/admin/invitations', this.form).then((response) => {
        Bus.$emit('refresh');
        this.resetForm();
      });
    },
  },
};
</script>
